import { useState, useEffect } from 'react';

export const useValidatedState = <T extends {}>(
    initialState: T,
    validator: (value: T) => boolean,
    initialValidity: boolean = true
): [T, (value: T) => void, boolean] => {
    const [state, setInternalState] = useState<T>(initialState);
    const [valid, setValid] = useState<boolean>(initialValidity);

    useEffect(() => {
        setInternalState(initialState);
        setValid(initialValidity);
    }, [initialState, initialValidity]);

    const setState = (value: T) => {
        const isValid = validator(value);
        setInternalState(value);
        setValid(isValid);
    };

    return [state, setState, valid];
};
